import { kebabCase } from 'nano-string-utils'

export interface FormIdInjection {
  id: string | undefined
}

export function useInjectedId(name: string | undefined = undefined) {
  const $form = inject($FormId, undefined)

  const elementId = computed(() => {
    if ($form?.id && name) {
      const suitableName = kebabCase(name)
      return `${$form.id}-${suitableName}`
    } else {
      return undefined
    }
  })

  return {
    id: $form?.id,
    elementId: elementId
  }
}
